import React, { useMemo } from "react";
import api from "@/lib/api";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import { ConnectComponentsProvider } from "@stripe/react-connect-js";
import { AlertCircle } from "lucide-react";

const APPEARANCE = {
  colorPrimary: "#FF6A00",
  colorBackground: "#09090b",
  colorText: "#e4e4e7",
  colorSecondaryText: "#a1a1aa",
  colorBorder: "#27272a",
  formBackgroundColor: "#18181b",
  offsetBackgroundColor: "#111113",
  buttonPrimaryColorBackground: "#FF6A00",
  buttonPrimaryColorText: "#ffffff",
  buttonSecondaryColorBackground: "#27272a",
  buttonSecondaryColorText: "#e4e4e7",
  badgeSuccessColorBackground: "rgba(16,185,129,0.15)",
  badgeSuccessColorText: "#34d399",
  overlayBackdropColor: "rgba(0,0,0,0.6)",
};

export default function StripeConnectProvider({ publishableKey, children }) {
  const connectInstance = useMemo(() => {
    if (!publishableKey) return null;
    return loadConnectAndInitialize({
      publishableKey,
      fetchClientSecret: async () => {
        const { data } = await api.post("/connect/account-session");
        if (!data.client_secret) throw new Error("no client secret");
        return data.client_secret;
      },
      appearance: { variables: APPEARANCE },
    });
  }, [publishableKey]);

  if (!publishableKey || !connectInstance) {
    return (
      <p data-testid="stripe-noconfig" className="flex items-center gap-2 py-8 text-sm text-zinc-400">
        <AlertCircle className="h-4 w-4" />La clé Stripe n'est pas configurée. Contactez le support.
      </p>
    );
  }
  return <ConnectComponentsProvider connectInstance={connectInstance}>{children}</ConnectComponentsProvider>;
}
